import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ListAdjustmentModalComponent } from 'src/app/shared/list-views/list-layout/list-adjustment-modal/list-adjustment-modal.component';
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';


@Injectable({
  providedIn: 'root'
})
export class ListAdjustmentService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(tableConfig: TableConfigurationModel, defaultTableConfig: TableConfigurationModel|undefined) {
    var modalRef!: NgbModalRef;
        if(tableConfig == null){
            tableConfig = new TableConfigurationModel(); 
        }
        modalRef = this.modalService.open( ListAdjustmentModalComponent, {windowClass : "myCustomModalClassUnderTopBar", size: 'xl', centered: false, backdrop: 'static', keyboard: false, scrollable: true });
        modalRef.componentInstance.tableConfig = tableConfig;
        modalRef.componentInstance.defaultTableConfig = defaultTableConfig;
        var sub: Subscription =  modalRef.closed.subscribe(()=>{
          this.modelChanged.emit(modalRef.componentInstance.newTableConfig)
          sub.unsubscribe();
        })
  }
}